const replaceWithHomeAwayCurrencySymbol = require('./currencyInfo')
    .replaceWithHomeAwayCurrencySymbol;
const getCorrectedCurrencySymbol = require('./currencyInfo')
    .getCorrectedCurrencySymbol;
const CURRENCY_PRECISIONS = require('./currencyInfo').CURRENCY_PRECISIONS;
const localeCurrency = require('locale-currency');
const i18nFormatter = require('./i18nFormatter').I18nFormatter;

const CurrencyFormatter = {
    /**
     * Formats the specified amount for the given locale and currency.
     * This logic was taken from https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/java/com/homeaway/commons/i18n/formatter/GlobalCurrencyFormatter.java#L239
     *
     * @param value the number value to format
     * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
     * @param locale the locale to determine the format of the result (defaults to 'en_US')
     * @param maximumFractionDigits the maximum number of fraction digits to keep (default to 2)
     * @param minimumFractionDigits the minimum number of fraction digits to keep (default to 0)
     * @param useGrouping whether to use separator between thousands (default to true)
     * @returns The formatted amount with correct currency symbol based on the locale and currency
     */
    formatNumber({
        value,
        currencyCode,
        locale = 'en_US',
        maximumFractionDigits = 2,
        minimumFractionDigits = 0,
        useGrouping = true
    }) {
        const currency = currencyCode || localeCurrency.getCurrency(locale);
        const options = {
            value,
            currency,
            locale,
            currencyDisplay: 'code',
            maximumFractionDigits,
            minimumFractionDigits,
            style: 'currency',
            useGrouping
        };

        try {
            return replaceWithHomeAwayCurrencySymbol(
                i18nFormatter.formatNumber(options),
                currency,
                locale
            );
        } catch (e) {
            return String(value);
        }
    },

    /**
     * Resolves currency symbol based on currency code and locale
     *
     * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
     * @param locale the locale to determine the format of the result (defaults to 'en_US')
     * @returns string symbol based on ISO 4217 Currency Code.
     */
    symbol(currencyCode, locale = 'en_US') {
        if (!currencyCode) {
            return '';
        }
        return getCorrectedCurrencySymbol(currencyCode, locale) || currencyCode;
    },

    /**
     * Returns currency precision based on ISO 4217.
     * @param currencyCode {String} three-letter currency code as found in keys of CURRENCY_CODES
     * @returns {Number} currency precision, default value is 2
     */
    precision(currencyCode) {
        return CURRENCY_PRECISIONS.hasOwnProperty(currencyCode)
            ? CURRENCY_PRECISIONS[currencyCode]
            : 2;
    }
};

module.exports = {
    CurrencyFormatter
};
